export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12673.d0ffb7c2.jpg";